module.exports = __webpack_public_path__ + "static/media/image4.f54fa5d9.png";